import { Component, OnInit, NgZone, OnDestroy } from "@angular/core";
import { FormGroup, FormControl, Validators } from '@angular/forms';
import MediaQueries from '../util/media-queries-helper';
import { Router } from "@angular/router";
import { EmailService } from '../email-service';

declare var $: any;

@Component({
    selector: 'contact-page',
    templateUrl: './contact-page.component.html',
    styleUrls: ['./contact-page.component.scss']
})
export class ContactPageComponent implements OnInit, OnDestroy {

    public elm = document.getElementById("navbar");
    public elm2 = document.getElementById("myNavbar");
    public tabMenu = document.getElementById("tabMenu");

    contact: FormGroup;

    constructor(private router: Router, private emailService: EmailService, private _NgZone: NgZone) {

        // console.log(this.tabMenu)
        this.tabMenu.remove()
        var navbar = "<ul _ngcontent-c1 class='nav navbar-nav justify-content-end text-right' id='tabMenu2'>"
            + "<li _ngcontent-c1 class='details'><a _ngcontent-c1 class='tab' routerLink='/home' ng-reflect-router-link='/home' href='/home'>HOME</a></li>"
            + "<li _ngcontent-c1 class='details'><a _ngcontent-c1 class='tab' routerLink='/aboutUs' ng-reflect-router-link='/aboutUs' href='/aboutUs'>ABOUT US</a></li>"
            + "<li _ngcontent-c1 class='details'><a _ngcontent-c1 class='tab' routerLink='/contact' ng-reflect-router-link='/contact' href='/contact'>CONTACT</a></li>"
            + "</ul>";
        this.elm2.insertAdjacentHTML('afterbegin', navbar);

        if ($(window).width() < 1081) {
            this.elm.style.background = 'linear-gradient(to right, black, #181818, #292929, #084466)';
            this.elm2.style.background = 'rgba(41, 41, 41, 0.8)';
        } else {
            this.elm.style.background = 'transparent';
        }

        MediaQueries.matcheQuery("xl").addListener((/*mql: MediaQueryList*/) => {
            _NgZone.run(() => {
                if (MediaQueries.querySelect() == 'xl') {
                    this.elm.style.background = 'transparent';
                } else {
                    this.elm.style.background = 'linear-gradient(to right, black, #181818, #292929, #084466)';
                    this.elm2.style.background = 'rgba(41, 41, 41, 0.8)';
                }
            });
        });

        this.contact = new FormGroup({
            name: new FormControl('', [Validators.required, Validators.min(3), Validators.maxLength(20)]),
            email: new FormControl('', [Validators.email, Validators.required]),
            subject: new FormControl('', [Validators.required, Validators.maxLength(50)]),
            message: new FormControl('', [Validators.required])
        })
    }

    onSubmit() {
        if (this.contact.valid) {
            let body = {
                "Template": {
                    "TemplateName": "NewVision",
                    "Keys": ["fullname", "email", "subject", "message"],
                    "Values": { "fullname": this.contact.value.name, "email": this.contact.value.email, "subject": this.contact.value.subject, "message": this.contact.value.message }
                }
            }
            this.emailService.sendTemplateEmail('info@visionborne.us', body).subscribe(response => { /*console.log(response)*/ });
            this.contact.reset();
            // this.router.navigate(['/home']);
        } else {
            this.validateAllFormFields(this.contact);
        }
    }

    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({ onlySelf: true });
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }

    ngOnInit() { }

    ngOnDestroy(): void {
        this.elm.style.background = 'transparent';
        this.elm2.style.backgroundColor = 'transparent';

        var tabName = document.getElementById("tabMenu2");
        if (tabName) {
            // console.log('tabName-> ', tabName)
            document.getElementById("tabMenu2").remove();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/contact-page/contact-page.component.ts